<template>
  <path
    d="M12 22.0002C13.1 22.0002 14 21.1002 14 20.0002H10C10 21.1002 10.89 22.0002 12 22.0002ZM18 11.0002C18 7.93024 16.36 5.36024 13.5 4.68024V4.00024C13.5 3.17024 12.83 2.50024 12 2.50024C11.17 2.50024 10.5 3.17024 10.5 4.00024V4.68024C10.26 4.74024 10.03 4.83024 9.81 4.91024L18 13.1002V11.0002ZM5.41 3.35024L4 4.76024L6.81 7.57024C6.29 8.57024 6 9.73024 6 11.0002V16.0002L4.71 17.2902C4.08 17.9202 4.52 19.0002 5.41 19.0002H18.24L19.98 20.7402L21.39 19.3302L5.41 3.35024Z"
  />
</template>
